<template>
  <v-modal v-if="loaded" id="modal-report-firme" :is-big="true" :modal="false">
    <span slot="header"> {{ i18nJS['domestics.reports.report_firme'] }}<br /> </span>
    <slot name="body">
      <div class="flex">
        <div class="filters flex flex-cols">
          <template v-if="filterByDate">
            <datepicker
              class="input_date obbligatorio"
              v-model="filters.from"
              placeholder="Dal"
              :required="filterByDate"
              id="date_from"
              style="width: 206px"
            />
            <div class="spacer" />
            <datepicker
              class="input_date obbligatorio"
              v-model="filters.to"
              placeholder="Al"
              :required="filterByDate"
              id="date_to"
              style="width: 206px"
            />
          </template>
          <template v-else>
            <v-select2 v-if="months" v-model="filters.month" :options-list="months" :data-allow-clear="false" :data-minimumInputLength="1">
            </v-select2>
            <div class="spacer" />
            <v-select2 v-if="years" v-model="filters.year" :options-list="years" :data-allow-clear="false" :data-minimumInputLength="1">
            </v-select2>
          </template>
          <div class="spacer" />
          <div v-if="!treeListViewFilter">
            <v-select2
              v-model="filters.guestSelected"
              :multiple="true"
              :data-placeholder="i18nJS.guest_label"
              :data-ajax--url="`${guestUrl}`"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
            <v-select2
              v-model="filters.departmentSelected"
              :multiple="false"
              :data-placeholder="i18nJS['domestics.daily_table.department']"
              :options-list="departmentOptionsList"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
            <v-select2
              v-model="filters.userSelected"
              :multiple="false"
              :data-placeholder="i18nJS.user_label"
              data-ajax--url="/it/users?type[]=presents&type[]=cessati"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
            <v-select2
              v-model="filters.activitySelected"
              :multiple="true"
              :data-placeholder="i18nJS.activities"
              :data-ajax--url="activityAjaxUrl"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
          </div>
          <div v-else>
            <div class="tree-max">
              <a class="button" @click="loadActivities(false)">{{ i18nJS.activities }}</a>
              <div v-if="activityShow">
                <template v-if="activityOptionsList.length">
                  <div v-for="(activity, idx) in activityOptionsList" :key="idx">
                    <input type="checkbox" :value="activity.id" v-model="filters.activitySelected" />&nbsp;{{ activity.label }}
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
            <div class="tree-max">
              <a class="button" @click="loadGuests(false)">{{ i18nJS.guest_label }}</a>
              <div v-if="guestShow">
                <template v-if="guestOptionsList.length">
                  <div v-for="(guest, idx) in guestOptionsList" :key="idx">
                    <input type="checkbox" :id="`guest_${guest.id}`" :value="guest.id" v-model="filters.guestSelected" />&nbsp;{{
                      guest.label
                    }}
                    <label :for="`guest_${guest.id}`"></label>
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
            <div class="tree-max">
              <a class="button" @click="loadDepartments()">{{ i18nJS['domestics.daily_table.department'] }}</a>
              <div v-if="departmentShow">
                <input type="checkbox" :value="null" v-model="filters.departmentSelected" />&nbsp;{{ i18nJS.no_preference }}
                <template v-if="departmentOptionsList.length">
                  <div v-for="(bu, idx) in departmentOptionsList" :key="idx">
                    <input type="checkbox" :value="bu.id" v-model="filters.departmentSelected" />&nbsp;{{ bu.label }}
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
            <div class="tree-max">
              <a class="button" @click="loadUsers(false)"
                >{{ i18nJS.user_label }}
                <span v-if="usersIsLoading">{{ i18nJS.is_loading }}</span>
              </a>
              <div v-if="userShow">
                <template v-if="userOptionsList.length">
                  <div v-for="(user, idx) in userOptionsList" :key="idx">
                    <input type="checkbox" :value="user.id" v-model="filters.userSelected" />&nbsp;{{ user.label }}
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
          </div>
          <div class="">
            <label>{{ i18nJS['filter_sign.title'] }}</label>
            <label for="all" class="inline">
              <input type="radio" id="all" value="all" v-model="filters.signed" />
              {{ i18nJS.all }}
            </label>
            <label for="signed" class="inline">
              <input type="radio" id="signed" value="signed" v-model="filters.signed" />
              {{ i18nJS['filter_sign.signed'] }}
            </label>
            <label for="unsigned" class="inline">
              <input type="radio" id="unsigned" value="unsigned" v-model="filters.signed" />
              {{ i18nJS['filter_sign.unsigned'] }}
            </label>
          </div>
        </div>

        <div id="doc-output">
          <p v-if="srcPreviewPdf && !loading && !creatingPdf" class="text-center">
            {{ i18nJS['domestics.reports.report_firme_instructions'] }}
            <a class="button-download" @click="downloadPdf()">{{ i18nJS.here }}</a>
          </p>
          <embed v-if="srcPreviewPdf && !loading" :src="srcPreviewPdf" type="application/pdf" width="100%" height="100%" />
          <p v-if="!srcPreviewPdf && !loading" class="text-center">{{ i18nJS.no_data }}</p>
          <p v-if="loading" class="text-center">{{ i18nJS.loading }}</p>
          <p v-if="creatingPdf" class="text-center">{{ i18nJS.loading_pdf }}</p>
          <p v-if="showErrors" class="text-center">{{ i18nJS['errors.critical_error'] }}</p>
        </div>
      </div>
    </slot>
  </v-modal>
</template>
<script>
import { LabelApi } from '@/epersonam/mixins/labels.js';
import apiConnector from '@/epersonam/apiConnector';
import vModal from '../vModal';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import { getPdf, downloadPdf } from './template';
import DOMPurify from 'dompurify';
import { Route } from '../../route';

export default {
  name: 'modalReportFirme',
  mixins: [LabelApi],
  components: {
    vModal,
    vSelect2,
    datepicker,
  },
  async beforeMount() {
    this.neededlabels = [
      'no_data',
      'loading',
      'loading_pdf',
      'errors.critical_error',
      'domestics.reports.report_firme',
      'domestics.reports.report_firme_instructions',
      'here',
      'is_loading',
      'user_label',
      'domestics.daily_table.department',
      'no_preference',
      'filter_sign.title',
      'all',
      'filter_sign.signed',
      'total',
      'activity',
      'data',
      'filter_sign.unsigned',
      'guest_label',
      'activities',
      'siat_practice',
      'dalle_ore',
      'alle_ore',
      'total_holiday',
      'total_weekday',
      'domestics.reports.sign_user_in_charge',
      'operator',
      'search_activities',
      'user_signature',
      'signature',
    ];
    await this.setupLabels();
    this.loaded = true;
  },
  mounted() {
    eventBus.$on('openModalReportFirme', () => {
      if (!this.filterByDate) {
        this.months = Object.keys(this.i18nJS.months).map((month, index) => {
          return [this.i18nJS.months[month], String(index + 1).padStart(2, '0')];
        });
        this.years = Array.from(new Array(this.currentYear - 2000).keys()).map((ele) => [
          String(this.currentYear - ele),
          String(this.currentYear - ele),
        ]);
      }
      if (!this.treeListViewFilter) {
        if (this.departmentOptionsList.length === 0) {
          apiConnector()
            .get(`/${window.locale}/business_units/units_list.json?business_unit_id=${this.currentBuId}`)
            .then(({ data }) => {
              this.departmentOptionsList = data;
            })
            .catch((err) => {
              console.err('Could not initialize departmentOptionsList', err);
            });
        }
      }
      $('#modal-report-firme').modal('show');
      this.load();
      this.srcPreviewPdf = null;
    });
  },
  computed: {
    activityAjaxUrl() {
      return `/${window.locale}/activities_configs`;
    },
  },
  props: {
    currentBuId: {
      type: Number,
      required: true,
      default: 0,
    },
    currentBuLogo: {
      type: String,
      required: true,
      default: null,
    },
    treeListViewFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterByDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    withPrId: {
      type: Boolean,
      required: false,
      default: false,
    },
    withUserSignature: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    let additionalFilters = {};
    if (this.filterByDate) {
      additionalFilters = {
        from: moment().startOf('month').format('L'),
        to: moment().endOf('month').format('L'),
      };
    } else {
      additionalFilters = {
        month: moment().format('MM'),
        year: `${new Date().getFullYear()}`,
      };
    }
    return {
      loaded: false,
      srcPreviewPdf: null,
      filters: {
        ...additionalFilters,
        signed: 'all',

        guestSelected: this.treeListViewFilter ? [] : null,
        userSelected: this.treeListViewFilter ? [] : null,
        departmentSelected: this.treeListViewFilter ? [] : null,
        activitySelected: this.treeListViewFilter ? [] : null,
      },
      loading: false,
      creatingPdf: false,
      showErrors: false,
      months: [],
      years: [],
      currentYear: new Date().getFullYear(),

      // Options list
      userOptionsList: [],
      activityOptionsList: [],
      activityIsLoading: false,
      activityPaginationPage: 1,
      guestBusinessUnitsOptionsList: [],
      departmentOptionsList: [],
      guestOptionsList: [],

      userShow: false,
      usersIsLoading: false,
      activityShow: false,
      guestShow: false,
      departmentShow: false,

      // URL FOR RETRIVE DATA FOR TREE-LIST-VIEW
      baseUrl: window.config.ePersonamService.ePersonamHost + '/' + window.locale,
      baseFormat: '.json',
      // url per lista utenti in base alle mansioni
      loadUsersUrl: '/users',
      loadUsersOutedUrl: '/users/outed',
      usersPage: 1,
      // url per la lista delle attività filtrati per area
      loadActivitiesUrl: '/activities_configs',
      // url per la lista delle sub attività filtrati per attività
      loadDepartmentsUrl: '/business_units/units_list',
      // url per la lista delle sub attività filtrati per attività
      loadGuestsUrl: '/guests',
      guestsPage: 1,
      guestUrl: `${Route.GUEST_BUSINESS_UNIT_AUTOCOMPLETE_GUESTS_FULL_NAME}?from_report_firme=true`,
    };
  },
  destroyed() {
    console.log('Ho distrutto il modale!');
  },
  methods: {
    loadUsers(nextPage) {
      if (!this.treeListViewFilter) {
        return;
      }
      if (!nextPage && this.userOptionsList?.length) {
        this.userShow = this.userShow !== true;
        return;
      }
      this.usersIsLoading = true;
      const calls = [
        apiConnector().get(this.baseUrl + this.loadUsersUrl + this.baseFormat, { params: { page: this.usersPage } }),
        apiConnector().get(this.baseUrl + this.loadUsersOutedUrl + this.baseFormat, { params: { page: this.usersPage } }),
      ];
      Promise.all(calls)
        .then(([res1, res2]) => {
          res1.data.forEach((val) => {
            if (!val.surname || !val.firstname) {
              return;
            }

            this.userOptionsList.push({ id: val.id, label: `${val.surname} ${val.firstname}` });
          });
          res2.data.forEach((val) => {
            if (!val.full_name) {
              return;
            }
            this.userOptionsList.push({ id: val.id, label: val.full_name });
          });
          this.userOptionsList.sort(function (a, b) {
            return a.label.localeCompare(b.label);
          });

          if (res1.data.length || res2.data.length) {
            this.usersPage += 1;
            this.loadUsers(true);
          } else {
            this.usersIsLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.userShow = true;
    },
    loadActivities(nextPage) {
      if (!this.treeListViewFilter) {
        return;
      }
      if (!nextPage && this.activityOptionsList?.length) {
        this.activityShow = this.activityShow !== true;
        return;
      }
      apiConnector()
        .get(this.baseUrl + this.loadActivitiesUrl + this.baseFormat, {
          params: {
            business_unit_id: this.currentBuId,
            type: 'activity',
            page: this.activityPaginationPage,
          },
        })
        .then(({ data: res }) => {
          res.forEach((val) => {
            this.activityOptionsList.push({ id: val.id, label: val.description });
            this.activityShow = true;
          });

          if (res.length) {
            this.activityIsLoading = true;
            this.activityPaginationPage += 1;
            this.loadActivities(this.activityIsLoading);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadDepartments() {
      if (!this.treeListViewFilter) {
        return;
      }
      if (this.departmentOptionsList?.length) {
        this.departmentShow = this.departmentShow !== true;
        return;
      }
      apiConnector()
        .get(this.baseUrl + this.loadDepartmentsUrl + this.baseFormat, { params: { business_unit_id: this.currentBuId } })
        .then(({ data: res }) => {
          res.forEach((val) => {
            if (this.departmentOptionsList?.findIndex((x) => x.id === val[1] || x.label === val[0]) !== -1) {
              return;
            }
            this.departmentOptionsList.push({ id: val[1], label: val[0] });
            this.departmentShow = true;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadGuests(nexPage) {
      if (!this.treeListViewFilter) {
        return;
      }
      if (!nexPage && this.guestOptionsList.length) {
        this.guestShow = this.guestShow !== true;
        return;
      }
      apiConnector()
        .get(this.baseUrl + this.loadGuestsUrl + this.baseFormat, { params: { page: this.guestsPage, with_gpds: true } })
        .then(({ data: res }) => {
          res.forEach((val) => {
            this.guestOptionsList.push({ id: val.guest_business_unit_id, label: val.full_name });
            this.guestShow = true;
          });
          if (res.length !== 0) {
            this.guestsPage += 1;
            this.loadGuests(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // TreeView filter query - FINE

    selectAllUser(userList) {
      userList.forEach((user) => {
        if (this.jobSelectedAll) {
          let index = this.filters.userSelected.indexOf(user.id);
          if (index > -1) {
            this.filters.userSelected.splice(index, 1);
          }
        } else {
          this.filters.userSelected.push(user.id);
        }
      });
      this.jobSelectedAll = this.jobSelectedAll !== true;
    },

    selectAllArea(areaList) {
      areaList.forEach((area) => {
        if (this.areaSelectedAll) {
          let index = this.filters.activitySelected.indexOf(area.id);
          if (index > -1) {
            this.filters.activitySelected.splice(index, 1);
          }
        } else {
          this.filters.activitySelected.push(area.id);
        }
      });
      this.areaSelectedAll = this.areaSelectedAll !== true;
    },

    async loadData(preview = true) {
      if (preview) {
        this.loading = true;
      }

      const data = await this.getUsersDomestics(preview);
      if (preview) {
        this.loading = false;
      }
      return data;
    },
    async normalizeElement(activity) {
      const from = new Date(activity.start);
      const to = new Date(activity.end);

      let activity_value = '';
      if (activity.sub_activities_configs_description) {
        const sub_activities_descriptions = activity.sub_activities_configs_description.join('\n');
        activity_value = `${activity.activities_configs_description} \n${sub_activities_descriptions}`;
      } else if (activity.activities_configs_description) {
        activity_value = activity.activities_configs_description;
      }
      let operator_value = `${activity.surname} ${activity.firstname}`;

      if (this.filterByDate) {
        if (activity.motivation) {
          activity_value = `${activity_value} \n${activity.motivation || ''}`;
        }

        operator_value = activity.operators.map((operator) => `${operator.firstname} ${operator.surname}`).join('\n');
      }

      let normalizedElement = {
        cf: activity.guests_cf,
        fullname: `${activity.guests_surname} ${activity.guests_firstname}`,
        data: `${String(from.getDate()).padStart(2, '0')}/${String(from.getMonth() + 1).padStart(2, '0')}/${from.getFullYear()}`,
        fromHours: `${String(from.getHours()).padStart(2, '0')}:${String(from.getMinutes()).padStart(2, '0')}`,
        toHours: `${String(to.getHours()).padStart(2, '0')}:${String(to.getMinutes()).padStart(2, '0')}`,
        total: activity.duration,
        operator: operator_value,
        activity: activity_value,
        isHoliday: activity.is_holiday,
      };

      if (this.withPrId) {
        normalizedElement.siat_practice = activity.siat_practice;
      }

      if (this.withUserSignature) {
        if (activity.user_signature?.startsWith('<?xml')) {
          const parser = new DOMParser();
          const signature = parser.parseFromString(DOMPurify.sanitize(activity.user_signature), 'image/svg+xml');
          const baseVal = signature?.firstChild?.viewBox?.baseVal || null;

          normalizedElement.userSignIsImage = true;
          if (baseVal?.height > baseVal?.width) {
            signature.firstChild.setAttribute('transform', 'rotate(-90, 15, 15)');
            normalizedElement.userRotateSign = true;
          }
          normalizedElement.userSignature = signature.firstChild;
        } else if (activity.user_signature) {
          normalizedElement.userSignature = activity.user_signature;
        } else {
          normalizedElement.userSignature = '';
        }
      }

      if (activity.signature?.startsWith('<?xml')) {
        const parser = new DOMParser();
        const signature = parser.parseFromString(DOMPurify.sanitize(activity.signature), 'image/svg+xml');
        const baseVal = signature?.firstChild?.viewBox?.baseVal || null;

        normalizedElement.signIsImage = true;
        if (baseVal?.height > baseVal?.width) {
          signature.firstChild.setAttribute('transform', 'rotate(-90, 15, 15)');
          normalizedElement.rotateSign = true;
        }
        normalizedElement.signUserInCharge = signature.firstChild;
      } else if (activity.signature) {
        normalizedElement.signUserInCharge = activity.signature;
      } else {
        normalizedElement.signUserInCharge = '';
      }
      return normalizedElement;
    },
    getPdfLabels() {
      return {
        data: this.i18nJS.data,
        activity: this.i18nJS.search_activities,
        siat_practice: this.i18nJS.siat_practice,
        fromHours: this.i18nJS.dalle_ore,
        toHours: this.i18nJS.alle_ore,
        total: this.i18nJS.total,
        totalHoliday: this.i18nJS.total_holiday,
        totalWeekday: this.i18nJS.total_weekday,
        signUserInCharge: this.withUserSignature ? this.i18nJS.signature : this.i18nJS['domestics.reports.sign_user_in_charge'],
        operator: this.i18nJS.operator,
        titleReport: this.i18nJS['domestics.reports.report_firme'],
        page: this.i18nJS.page,
        from: this.i18nJS.from,
        to: this.i18nJS.to,
        userSignature: this.i18nJS.user_signature,
      };
    },
    async createPreviewPdf(acc) {
      this.creatingPdf = true;
      let additionalParams = {};
      if (this.filterByDate) {
        additionalParams = {
          from: moment(this.filters.from, 'DD/MM/YYYY').format('LL'),
          to: moment(this.filters.to, 'DD/MM/YYYY').format('LL'),
        };
      } else {
        additionalParams = {
          month: this.months[Number(this.filters.month) - 1][0],
          year: this.filters.year,
        };
      }

      additionalParams.withPrId = this.withPrId;
      additionalParams.withUserSignature = this.withUserSignature;

      this.srcPreviewPdf = await getPdf(acc, this.getPdfLabels(), {
        logo: await this.getLogo(),
        ...additionalParams,
      });
      this.creatingPdf = false;
    },
    async createDownloadPdf(acc) {
      let additionalParams = {};
      if (this.filterByDate) {
        additionalParams = {
          from: moment(this.filters.from, 'DD/MM/YYYY').format('LL'),
          to: moment(this.filters.to, 'DD/MM/YYYY').format('LL'),
        };
      } else {
        additionalParams = {
          month: this.months[Number(this.filters.month) - 1][0],
          year: this.filters.year,
        };
      }

      additionalParams.withUserSignature = this.withUserSignature;

      await downloadPdf(acc, this.getPdfLabels(), {
        logo: await this.getLogo(),
        ...additionalParams,
      });
    },
    async load() {
      this.srcPreviewPdf = null;
      const list = await this.loadData();
      if (list.length > 0) {
        this.createPreviewPdf(list);
      }
    },
    async getUsersDomestics(preview = true) {
      let page = 1,
        per_page = 70;
      let records = [];
      let keepGoing = true;
      while (keepGoing) {
        let response = await this.requestDomestics(page, per_page);
        let acc = [];
        let domestics = response?.data?.domestic_activities;

        if (domestics?.length > 0) {
          for (let index = 0; index < domestics.length; index++) {
            acc.push(await this.normalizeElement(domestics[index]));
          }
        }
        await records.push.apply(records, acc);

        if (!response || !Array.isArray(domestics) || preview || response.data.stop_loading) {
          keepGoing = false;
          return records;
        }
        page += 1;
      }
    },
    async requestDomestics(page, per_page) {
      let params = {
        business_unit_id: this.currentBuId,
        from: `${this.filters.month}/${this.filters.year}`,
        page,
        per_page,
        signed: this.filters.signed,
      };

      if (this.filterByDate) {
        params = {
          ...params,
          from: this.filters.from,
          to: this.filters.to,
          filter_by_date: this.filterByDate,
        };
      }

      if (this.filters.guestSelected && this.filters.guestSelected.length > 0) {
        params.guest_id = this.filters.guestSelected;
      }
      if (this.filters.userSelected && this.filters.userSelected.length > 0) {
        params.user_id = this.filters.userSelected;
      }
      if (this.filters.departmentSelected && this.filters.departmentSelected.length > 0) {
        params.department_id = this.filters.departmentSelected;
      }
      if (
        this.filters.activitySelected &&
        this.filters.activitySelected.length > 0 &&
        this.filters.activitySelected.filter((activity) => activity !== '').length > 0
      ) {
        params.activity_id = this.filters.activitySelected;
      }

      let canGet = false;

      if (this.filterByDate) {
        canGet = this.filters.from && this.filters.to;
      } else {
        canGet = this.filters.month && this.filters.year;
      }
      if (canGet) {
        return await apiConnector().get('/it/domestic/get_report_firme.json', { params });
      }
    },
    async downloadPdf() {
      Loader.show();
      const list = await this.loadData(false);
      if (list.length > 0) {
        await this.createDownloadPdf(list);
      }
      Loader.hide();
    },
    async getLogo() {
      // UNCOMMENT RETURN IF CORS ERROR
      // return
      const p = new Promise((resolve, reject) => {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function () {
          var fileReader = new FileReader();
          fileReader.onloadend = function () {
            resolve(fileReader.result);
          };
          fileReader.onerror = function (event) {
            reject('Failed to read logo!\n\n' + event.error);
          };
          fileReader.readAsDataURL(xhttp.response);
        };

        xhttp.responseType = 'blob';
        xhttp.open('GET', this.currentBuLogo, true);
        xhttp.send();
      });
      let data = null;
      await p.then((dataURL) => (data = dataURL)).catch((error) => console.error(error));
      return data;
    },
  },
  watch: {
    'filters.from': {
      handler() {
        this.load();
      },
    },
    'filters.to': {
      handler() {
        this.load();
      },
    },
    'filters.month': {
      handler() {
        this.load();
      },
    },
    'filters.year': {
      handler() {
        this.load();
      },
    },
    'filters.guestSelected': {
      handler() {
        this.load();
      },
    },
    'filters.userSelected': {
      handler() {
        this.load();
      },
    },
    'filters.departmentSelected': {
      handler() {
        this.load();
      },
    },
    'filters.activitySelected': {
      handler() {
        this.load();
      },
    },
    'filters.signed': {
      handler() {
        this.load();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
#doc-output {
  padding-left: 2%;
  width: calc(100% - 220px);

  embed {
    min-height: 70vh;
  }
}

#modal-report-firme {
  .modal-body {
    max-height: unset;
  }
}

.flex {
  display: flex;
}

.flex-cols {
  flex-direction: column;
}

.filters {
  max-width: 220px;
}

.button-pdf {
  border: unset;
  background-color: white;
}

.button-download {
  text-transform: uppercase;
  color: blue;
  text-decoration: underline;
}

.spacer {
  height: 20px;
}

.tree-max {
  max-height: 300px;
  overflow-y: auto;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;

  input {
    margin-top: 0;
  }

  .tree-child:first-child {
    margin: 2px 0 0 10px;
  }

  .tree-child {
    margin: 0 0 0 15px;
  }

  .element-father {
    position: relative;
    overflow-y: auto;

    .icon {
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
}
</style>
